<template>
  <!-- Read  Only Mode START -->

  <div v-if="mode == 'VIEW'">
    <div>
      <div class="instruction_title ql-editor p-0" v-html="question.formattedTitle"></div>
      <div
        class="
          instruction_info
          ql-editor
          p-0
          mt-18
        "
        v-html="question.formattedInformation"
      ></div>
      <div class="mt-15">
        <div>
          <div v-if="question.imageUrl">
            <img class="img-size" :src="question.imageUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Read  Only Mode END -->

  <!-- Edit Mode START -->

  <div v-else-if="mode == 'EDIT'">
    <div class="pt-41">
      <div class>
        Step Title
        <span class="gp-help-text fs-10 ml-15">80 character limit</span>
      </div>

      <quill-editor class="bg-white mb-30 text-left" v-model="question.formattedTitle" :options="editorOptionForQuestion" @input="characterLimitValidation(question.formattedTitle, charLimit80)"></quill-editor>
    </div>

    <div class="pt-14">
      <div class>
        Content
        <span class="gp-help-text fs-10 ml-15">Recommended character limit is 500. If you go beyond 750 characters, you might experience formatting issues.</span>
      </div>

      <quill-editor id="quillImage" class="instruction-screen bg-white mb-11 text-center" ref="privacyPolicyEditor" v-model="question.formattedInformation" :options="editorOption"></quill-editor>
    </div>

    <!--Image upload START  -->

    <div class="row pt-20">
      <div class="pb-10">Image:</div>
      <div class="row">
        <div
          class="
            col-xs-12 col-sm-2 col-md-2 col-lg-2
            pl-0
            pr-20
            image-box-margin
          "
        >
          <div class="row">
            <img v-if="question.imageUrl" class="img_size" :src="question.imageUrl" />
            <span v-else class="text-center img-placeholder-2">
              Accepted formats: <br />
              .png .jpeg
            </span>
          </div>
          <div class="row">
            <div class="file_container1">
              <label class="file_container_text_skin" for="file_upload">Upload Image</label>
              <a class="color_red cursor_pointer fs-15 mt-10 d-inline-block" v-if="question.imageUrl" @click="deleteImageUrl">
                <i class="fa fa-trash fs-18" aria-hidden="true"></i>
              </a>
              <input ref="fileInput" type="file" class="form-control-file" id="file_upload" accept="image/jpeg,image/png" @change="onImageUpload" />
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 p-0">
          <span class="pt-10 display-block color_898989">
            <ul>
              <li>Accepted formats: .png; .jpeg</li>
              <li>Min dimensions: 1080px x 1080px</li>
              <li>
                Large images will automatically resize to fit the width of the phone
              </li>
              <li>Image will automatically center</li>
              <li>Image will be placed below step content</li>
              <li>Only one image can be uploaded</li>
            </ul>
          </span>
        </div>
      </div>
    </div>

    <!--Image upload END  -->
  </div>

  <!-- Edit Mode END -->
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepSkinAnalyser",

  components: {
    quillEditor
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    showStep: {
      type: Boolean
    }
  },
  data() {
    return {
      editorOptionForQuestion: {
        placeholder: "Enter step title to describe the data collected (body part) which is used for export purposes.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      editorOption: {
        placeholder: "You will measure your [body area] three times. Place the device on your skin in the position shown below.",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      charLimit80: 80
    };
  },
  mounted() {
    this.init();
    if (!this.question.formattedInformation) {
      this.question.formattedInformation = "<p>You will measure your [body area] three times. Place the device on your skin in the position shown below.</p>";
    }
  },
  methods: {
    init() {
      if (!this.question.id) {
        this.$set(this.question, "formattedTitle", "");
        this.$set(this.question, "formattedInformation", "");
      } else {
        this.$set(this.question, "formattedTitle", this.question.formattedTitle);
        this.$set(this.question, "formattedInformation", this.question.formattedInformation);
      }
    },

    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },

    characterLimitValidation(dataOld, maxCount = 80) {
      let data = dataOld;
      //Strip HTML tags
      data = this.stripHtml(data);
      if (data.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
    },

    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      const ftitle = this.stripHtml(question.formattedTitle);

      if (ftitle === "") {
        //Validate Title
        errorObj.msg = "Step Title is required.";
        errorObj.isValid = false;
        return errorObj;
      }

      if (ftitle.length > 80) {
        errorObj.isValid = false;
        errorObj.msg = `Step Title cannot exceed 80 limit`;
        return errorObj;
      }

      return errorObj;
    },

    async onImageUpload(event) {
      const activityId = this.activityDetails.id;
      const self = this;
      const selectedImage = event.target.files[0];
      const validImage = await this.validateImage(selectedImage);

      if (!validImage) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(selectedImage);
      reader.onload = e => {
        const file = {
          fileName: selectedImage.name,
          contentType: selectedImage.type,
          sequence: this.question.sequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityUploadFact(activityId, file).then(
          response => {
            if (response.data.result.imageUrl) {
              self.question.imageUrl = response.data.result.imageUrl;
              self.question.imageId = response.data.result.imageId;
            }
            this.$toastr.success("Image uploaded successfully");
          },
          error => {
            self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(self.errorMsg);
            self.question.imageUrl = "";
            self.question.imageId = "";
          }
        );
      };
    },

    async validateImage(image) {
      const isValid = image && image.name && image.name.match(/.(png|jpg|jpeg)$/i);
      if (!isValid) {
        return false;
      }
      let hasValidDimension = false;

      // Validate Image dimention greater than 1080.
      try {
        hasValidDimension = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onload = event => {
            const img = new Image();
            img.onload = () => {
              if (img.width >= 1080 && img.height >= 1080) {
                resolve(true);
              }
              reject(false);
            };
            img.src = event.target.result;
          };
        });
      } catch (error) {
        hasValidDimension = false;
      }

      return isValid && hasValidDimension;
    },
    deleteImageUrl() {
      this.question.imageUrl = "";
      this.question.imageId = "";
      this.$refs.fileInput.value = null;
      this.$toastr.success("Image deleted successfully");
    }
  }
};
</script>

<style scoped lang="scss">
.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 110px;
  max-height: 110px;
  padding: 5px;
}

/deep/ .instruction-screen {
  .ql-container {
    .ql-editor {
      text-align: left;
    }
    .ql-editor[data-placeholder] {
      &.ql-blank {
        text-align: left;
      }
    }
  }
}

/deep/ .quill-editor {
  &.text-left {
    img {
      margin-left: 0;
    }
  }
}

.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}

.img-placeholder-2 {
  background: #fff;
  border: 2px dashed #d3dee3;
  display: block;
  padding: 38px 5px;
  color: 666669;
  opacity: 0.7;
  font-size: 12px;
  border-radius: 3px;
}

.file_container_text_skin {
  width: auto;
  height: 33px;
  margin: 4px 10px 11px -2px;
  padding: 3px 20px 3px;
  border-radius: 3px;
  border: solid 2px #c5d1d6;
  text-align: center;
  color: #4c8ce4;
  font-family: Roboto-Regular;
  font-size: 12px;
}

.delete-image {
  position: absolute;
  top: 190px;
  right: 20px;
}
</style>
